import { render } from "./app-home.vue?vue&type=template&id=3f048612"
const script = {}

import exportComponent from "/home/runner/work/beohoang98.github.io/beohoang98.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__